async function getCartItems() {
  let res = await fetch("/cart.js");
  let json = await res.json();
  return json.items;
}

// Merchant correction (state=admin-edit): POST the corrected design to the
// webservice, which re-runs the print pipeline and overwrites the order's ZIP
// on the print FTP. The options screen URL carries ref_id = the state id saved
// after the merchant's edit; ADMIN_EDIT.previousRef is the one stored on the
// order — the webservice swaps them if saving produced a new CC state id.
async function sendOrderCorrection(button) {
  const CFG = window.CONFIGURATOR || CONFIGURATOR;
  const currentRef =
    new URLSearchParams(location.search).get("ref_id") || CFG.ref_configuration;
  const frameParent = $j("#editorFrame").parent()[0];
  LoadMask.maskMessage(
    frameParent,
    "Envoi de la correction en production,\n merci de patienter..."
  );
  document.querySelector(".masked-element .mask").style.minHeight = "100vh";

  let json = {};
  let ok = false;
  try {
    const res = await fetch(
      window.SERVICE_URLS.api + "/order-pdf/regenerate?shop=" +
        encodeURIComponent(window.Shopify?.shop || ""),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          shop: window.Shopify?.shop || "",
          order: window.ADMIN_EDIT.order,
          key: window.ADMIN_EDIT.key,
          previousRef: window.ADMIN_EDIT.previousRef,
          refConfiguration: currentRef,
        }),
      }
    );
    json = await res.json();
    ok = res.ok && (json.queued || json.uploaded);
  } catch (err) {
    json = { error: err.message };
  }

  LoadMask.unmaskElement(frameParent);
  if (ok) {
    button.disabled = true;
    const label = button.querySelector("span:last-child");
    if (label) label.textContent = "CORRECTION ENVOYÉE ✓";
    if (typeof noty === "function") {
      noty({
        text:
          "Correction envoyée : le fichier d'impression de la commande " +
          window.ADMIN_EDIT.order +
          " sera remplacé d'ici quelques minutes.",
        type: "success",
        timeout: 8000,
      });
    }
  } else {
    const msg = "Échec de l'envoi de la correction : " + (json.error || "erreur inconnue");
    if (typeof noty === "function") {
      noty({ text: msg, type: "error", timeout: 8000 });
    } else {
      alert(msg);
    }
  }
}

async function getProduct(item) {
  let data = {
    product: configJson.product,
    item: item,
  };

  let url =
    window.SERVICE_URLS.api + "/webhook/product?shop=" +
    encodeURIComponent(window.Shopify?.shop || "");

  let res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const errorText = await res.text();
    console.error("getProduct: API error", res.status, errorText);
    throw new Error("Erreur lors de la création du produit (" + res.status + ")");
  }

  let json = await res.json();
  console.log("getProduct response:", json);
  return json.hasOwnProperty("product")
    ? json.product.variants[0].id
    : json.variant.id;
}

document.addEventListener("DOMContentLoaded", function () {
  let addToCartBtn = document.querySelector("#approveButton");

  if (!addToCartBtn) {
    return;
  }

  // Merchant correction mode: the order is already paid, so the approve button
  // sends the corrected design to the print pipeline instead of the cart.
  if (window.ADMIN_EDIT && window.ADMIN_EDIT.order) {
    const label = addToCartBtn.querySelector("span:last-child");
    if (label) label.textContent = "ENVOYER LA CORRECTION";
  }

  addToCartBtn.addEventListener("click", async function () {
    if (window.ADMIN_EDIT && window.ADMIN_EDIT.order) {
      await sendOrderCorrection(addToCartBtn);
      return;
    }

    var frameParent = $j("#editorFrame").parent()[0];
    LoadMask.maskMessage(
      frameParent,
      "Nous préparons votre produit pour l'ajouter au panier,\n merci de patienter..."
    );
    document.querySelector(".masked-element .mask").style.minHeight = "100vh";
    if (mockupPreviewsImages.length == 0) {
      document.querySelectorAll(".media-viewer__item img").forEach((item) => {
        mockupPreviewsImages.push(item.src);
      });
    }

    // Use window.CONFIGURATOR for consistency across scripts
    const CFG = window.CONFIGURATOR || CONFIGURATOR;

    // Print format reference (e.g. "CSRV03") — the PDF webhook (cc.js)
    // reads jsconf.format.ref for the print filename and r/rv detection.
    const formatRef =
      (typeof current_format_ref !== "undefined" && current_format_ref) ||
      (typeof metafields_products !== "undefined" &&
        metafields_products.format &&
        metafields_products.format.ref) ||
      (configJson.format && configJson.format.ref) ||
      null;

    let jsConfData = {
      current_cut: CFG.current_cut,
      current_imposition: CFG.current_imposition,
      current_paper: CFG.current_paper,
      current_ribbon: CFG.current_ribbon,
      current_enveloppe: CFG.current_enveloppe,
      format_imposition: CFG.format_imposition,
      item_options: configJson.item_options,
      product: configJson.product,
      quantity: CFG.quantity,
      quantity_price: CFG.quantity_price,
      ref_configuration: CFG.ref_configuration,
      ref_profil: CFG.ref_profil,
      variant_id: configJson.variant_id,
    };

    if (formatRef) {
      jsConfData.format = { ref: formatRef };
    } else {
      console.error(
        "w-configurator-cart: format ref introuvable — la génération PDF échouera pour cet article"
      );
    }

    if (CFG.ref_texture) {
      jsConfData.ref_texture = CFG.ref_texture;
    }

    // Get proofsImages from CONFIGURATOR or fallback to empty array
    const proofsImagesData = CFG.proofsImages || [];
    if (!CFG.proofsImages || CFG.proofsImages.length === 0) {
      console.warn('w-configurator-cart: proofsImages is missing or empty');
    }

    let item = {
      quantity: 1,
      title: configJson.product?.title || "",
      properties: {
        _ref_configuration: CFG.ref_configuration,
        _preview: mockupPreviewsImages[0],
        _price: total_price,
        _userId: defaultEditorConfig.userId,
        _proofsImages: JSON.stringify(proofsImagesData),
        _jsconf: btoa(JSON.stringify(jsConfData)),
        Quantité: CFG.quantity,
        Format: CFG.current_format,
        Papier: CFG.current_paper,
      },
    };

    let paper = document.querySelector(
      '[data-id="papier"] .papier-value'
    )?.innerHTML;
    let cut = document.querySelector(
      '[data-id="decoupe"] .decoupe-value'
    )?.innerHTML;
    let ribbon = document.querySelector(
      '[data-id="ruban"] .ruban-value'
    )?.innerHTML;
    let enveloppe = document.querySelector(
      '[data-id="enveloppe"] .enveloppe-value'
    )?.innerHTML;

    let format = document.querySelector(
      '[data-id="format"] .format-value'
    )?.innerHTML;

    let impression_label = profils.find(
      (profil) => profil.ref_profil == CFG.ref_profil
    ).label_impression;

    let dorure_label = profils.find(
      (profil) => profil.ref_profil == CFG.ref_profil
    ).label_profil;

    let P = profils.find(
      (profil) => profil.ref_profil == CFG.ref_profil
    );

    let dorure = P.textures?.find(
      (texture) => texture.filename == CFG.ref_texture
    )?.ref_texture;

    let impression = P.name;

    if (impression_label && impression) {
      item.properties[impression_label] = impression.replace(/<[^>]*>?/gm, "");
    }

    if (dorure && dorure_label) {
      item.properties[dorure_label] = dorure.replace(/<[^>]*>?/gm, "");
    }

    if (paper) {
      item.properties.Papier = paper.replace(/<[^>]*>?/gm, "");
    }

    if (cut) {
      item.properties.Découpe = cut.replace(/<[^>]*>?/gm, "");
    }

    if (ribbon) {
      item.properties.Ruban = ribbon.replace(/<[^>]*>?/gm, "");
    }

    if (enveloppe) {
      item.properties.Enveloppe = enveloppe.replace(/<[^>]*>?/gm, "");
    }

    if (format) {
      item.properties.Format = format.replace(/<[^>]*>?/gm, "");
    }

    // Type and Format must travel as visible properties: checkout and order emails
    // only show line item properties, never the theme's Liquid-resolved data.
    // The options page exposes the source product (_product) and the format
    // metafield name (current_format_label) as globals.
    if (typeof _product !== "undefined" && _product?.type) {
      item.properties.Type = _product.type;
    }
    if (
      !item.properties.Format &&
      typeof current_format_label !== "undefined" &&
      current_format_label
    ) {
      item.properties.Format = current_format_label;
    }

    // Reorder line item properties for a consistent display across cart, drawer and
    // order (email follows the same stored order). Technical keys (_*) stay first and
    // remain hidden everywhere; visible options follow the product page order.
    // Impression/Dorure use profile-specific labels resolved above.
    const visibleOrder = [
      "Type",
      "Format",
      impression_label,
      "Papier",
      dorure_label,
      "Découpe",
      "Ruban",
      "Enveloppe",
      "Quantité",
    ];
    const orderedProperties = {};
    for (const key of Object.keys(item.properties)) {
      if (key.charAt(0) === "_") orderedProperties[key] = item.properties[key];
    }
    for (const key of visibleOrder) {
      if (key && Object.prototype.hasOwnProperty.call(item.properties, key)) {
        orderedProperties[key] = item.properties[key];
      }
    }
    for (const key of Object.keys(item.properties)) {
      if (!(key in orderedProperties)) orderedProperties[key] = item.properties[key];
    }
    item.properties = orderedProperties;

    let variant_id;
    try {
      variant_id = await getProduct(item);
    } catch (err) {
      console.error("getProduct failed:", err);
      LoadMask.unmaskElement(frameParent);
      if (typeof noty === "function") {
        noty({ text: "Erreur lors de la validation. Veuillez réessayer.", type: "error", timeout: 5000 });
      }
      return;
    }

    item.id = parseInt(variant_id);

    // check if cart has variant_id
    let cartItems = await getCartItems();
    let exists = false;
    cartItems.forEach((cartItem) => {
      if (cartItem.variant_id == variant_id) {
        exists = true;
      }
    });

    item.id = item.id.toString();

    if (exists) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          console.log(data);
          await wishlist.addCreation(item);
          window.location.href = "/cart";
        });
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    })
      .then(function (response) {
        return response.json();
      })
      .then(async function (data) {
        console.log(data);
        await wishlist.addCreation(item);
        window.location.href = window.location.href
          .replace("&view", "&cached")
          .replace("step=configurator_options", "view=upsell");
      });
  });
});
